import { z } from "zod";

export const uploadSignedUrlSchema = z.object({
  url: z.string(),
  uploadUrl: z.string()
});
export type UploadSignedUrl = z.infer<typeof uploadSignedUrlSchema>;
